import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import products from '../components/products/products.store'
import stocks from './modules/stocks'
import supplyOrders from './modules/supplyOrders'
import categories from './modules/category'
// import suppliers from './modules/supplier';
import suppliers from '../components/suppliers/suppliers.store'
import orders from '../components/orders/orders.store'
import inventory from '../components/inventory/inventory.store'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    products,
    stocks,
    supplyOrders,
    categories,
    suppliers,
    orders,
    inventory
  },
  state: {
    user: {
      id: null,
      name: null,
      email: null,
      gravatar: null,
      role: null
    },
    message: {
      type: 'success',
      body: 'Flash message used for notifications',
      show: false
    },
    showMenu: false,
    showSidebar: false,
    showCart: false
  },

  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js